import { MotifButton, MotifIcon } from '@ey-xd/motif-react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import iconSvg from '../../assets/icons/icon.svg.json';

const TemplateContentLoader = (props: any) => {
  const { uniqueReportCacheId } = props;
  const { contentForCurrentSlideInReport } = useSelector((state: any) => state.workspaces);
  const dispatch = useDispatch();

  const downloadGeneratedReport = () => {
    dispatch({
      type: 'WORKSPACE_DOWNLOAD_GENERATED_REPORT',
      payload: { uniqueReportCacheId }
    });
  };

  return (
    <div className="flex flex-col gap-3">
      <div className="flex gap-2 justify-between items-center">
        <p className="text-lg truncate">Select slide and prompt the change you want:</p>
        <MotifButton size="small" variant="primary" onClick={downloadGeneratedReport}>
          <MotifIcon src={iconSvg['download-file-icon']} className="w-5" title="Home" /> Download
        </MotifButton>
      </div>
      <div className="!h-[50vh] overflow-y-scroll bg-[#73737421] p-2 rounded-md">
        {!contentForCurrentSlideInReport ? (
          <div>
            <p>Loading content ...</p>
          </div>
        ) : (
          <div
            className="dynamic-content"
            dangerouslySetInnerHTML={{
              __html: contentForCurrentSlideInReport
            }}
          ></div>
        )}
      </div>
    </div>
  );
};

export default TemplateContentLoader;
